export default "__VITE_ASSET__Bl$hx6Zy__"